export enum KeyCodes {
  e = 'e',
  E = 'E',
  Enter = 'Enter',
  Minus = '-',
  Period = '.',
  Plus = '+',
}
